import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ShiftCancelledModalData {
  shiftId: string;
  facilityName: string;
  shiftDate: string;
}

@Injectable({ providedIn: 'root' })
export class ShiftCancelledModalService {
  private readonly _open$ = new Subject<ShiftCancelledModalData>();
  private readonly _closed$ = new Subject<'viewShift' | 'dismissed'>();

  /** Emits when the modal should be opened with the given data. */
  readonly open$ = this._open$.asObservable();

  /** Emits when the modal has been closed after an action. */
  readonly closed$ = this._closed$.asObservable();

  /** Request the layout to open the Shift Cancelled modal. */
  open(data: ShiftCancelledModalData): void {
    this._open$.next(data);
  }

  /** Notify subscribers that the modal was closed after an action. */
  notifyClosed(action: 'viewShift' | 'dismissed'): void {
    this._closed$.next(action);
  }
}
